export const tipoDeDocumentoEnum = {
  CNH: 'CNH',
  RG: 'RG',
  CPF: 'CPF',
  CertidaoDeNascimento: 'CertidaoDeNascimento',
  CertidaoDeCasamento: 'CertidaoDeCasamento',
  ComprovanteDeResidencia: 'ComprovanteDeResidencia',
  Procuracao: 'Procuracao',
  CartaoCNPJ: 'CartaoCNPJ',
  ContratoSocial: 'ContratoSocial',
  UltimaAlteracao: 'UltimaAlteracao',
  CertidaoJuntaComercial: 'CertidaoJuntaComercial',
  ComprovanteDeEnderecoDaEmpresa: 'ComprovanteDeEnderecoDaEmpresa',
  OutroDocumento: 'OutroDocumento',
  ComprovanteDePagamento: 'ComprovanteDePagamento',
  Checklist: 'Checklist',
} as const
export type TTipoDeDocumentoEnum = (typeof tipoDeDocumentoEnum)[keyof typeof tipoDeDocumentoEnum]

export const tipoDocumentoMap: Record<TTipoDeDocumentoEnum, string> = {
  CNH: 'CNH',
  CPF: 'CPF',
  CartaoCNPJ: 'Cartão CNPJ',
  CertidaoDeCasamento: 'Certidão de Casamento',
  CertidaoDeNascimento: 'Certidão de Nascimento',
  CertidaoJuntaComercial: 'Certidão Junta Comercial',
  Checklist: 'Checklist',
  ComprovanteDeEnderecoDaEmpresa: 'Comprovante de Endereço da Empresa',
  ComprovanteDePagamento: 'Comprovante de Pagamento',
  ComprovanteDeResidencia: 'Comprovante de Residência',
  ContratoSocial: 'Contrato Social',
  OutroDocumento: 'Outro Documento',
  Procuracao: 'Procuração',
  RG: 'RG',
  UltimaAlteracao: 'Última Alteração',
}
